<template>
  <div class="material-select">
    <b-dropdown
      :text="selectedText"
      v-if="options"
      :class="{ placeholder: selectedText === placeholder }"
      no-caret
      right
    >
      <template slot="button-content">
        <a class="action-btn">
          <img v-if="icon === 'edit'" src="~@/assets/icons/edit.svg" />
          <img v-if="icon !== 'edit'" src="~@/assets/icons/plus-grey.svg" />
        </a>
      </template>

      <input
        type="text"
        v-if="showSearch"
        v-model="search_term"
        class="search"
      />

      <b-dropdown-item
        :class="{ selected: values && values.includes(option.value) }"
        @click="onChange(option.value)"
        v-for="option of filtered_options"
        :key="option.value"
      >
        {{ option.text }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'AddMultiDropdown',
  data() {
    return {
      search_term: '',
      filtered_options: this.options,
    };
  },
  props: {
    options: [Array, Object],
    header: String,
    values: Array,
    onChange: Function,
    placeholder: String,
    showSearch: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'plus',
    },
  },
  computed: {
    selectedText() {
      if (!this.value) {
        return this.placeholder;
      }
      const option = this.options.find(opt => opt.value === this.value);
      return option.text;
    },
  },
  watch: {
    search_term(newValue) {
      const term = newValue.toLowerCase();
      if (!term) {
        this.filtered_options = this.options;
        return;
      }
      this.filtered_options = this.options.filter(opt => {
        return opt.text.toLowerCase().includes(term);
      });
    },
    options() {
      this.filtered_options = this.options;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.material-select {
  position: relative;
  padding-top: 15px;
  min-width: auto;

  ::v-deep .btn.btn-secondary,
  .btn.btn-secondary:focus {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
  }

  ::v-deep .dropdown-item {
    margin: 5px 0;
  }

  ::v-deep .dropdown-menu {
    max-height: 247px;
    min-width: 250px;
    overflow-y: auto;
    box-shadow: 0 0 14px 2px rgba(41, 42, 44, 0.09);
    border: 1px solid #e2e5ec !important;
  }

  .select-label {
    position: absolute;
    opacity: 0;
    transition: opacity 0.2s;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    top: 1px;
    pointer-events: none;
    color: #929da9;
    margin: 0;

    &.active {
      opacity: 1;
    }
  }

  .placeholder {
    ::v-deep .btn.dropdown-toggle {
      color: #929da9 !important;
    }
  }
}

.search {
  margin: 0 20px;
  border: none;
  outline: none !important;
  border-bottom: 1px solid #eee;
  padding: 5px 0 5px 20px;
  font-size: 14px;
  background-image: url('~@/assets/icons/search.svg');
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center left;
  width: 200px;
}
</style>
